import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { fetchDetails, resetDetails, showToast, deleteDetails, postCSV } from '../../actions'
import RoleControlled from '../_common/RoleControlled'
import EditOwner from '../Owners/EditOwner'
import EditResident from '../Residents/EditResident'
import Loader from '../_common/Loader'
import BackButton from '../_common/BackButton'
import axios from 'axios'
import { URL, deleteMsg, smsMessage } from '../../const'
import CSV from '../../assets/files/m_property.csv'

class Details extends PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      editMode: false,
      sendingSMS: false
    }
  }

  componentDidMount () {
    const { category, id } = this.props.match.params
    // console.log('id: ', id)
    this.props.fetchDetails(category, id)
  }
  componentWillUnmount () {
    this.props.resetDetails()
  }

  _handleDeleteClick () {
    const res = window.confirm(deleteMsg)
    if (res) {
      const { category, id } = this.props.match.params
      // console.log('category: ', category)
      // console.log('id: ', id)
      const redirect = function () {
        this.props.history.replace(`/${category}`)
      }
      this.props.deleteDetails(category, id, redirect.bind(this))
    }
  }
  _handleEditClick () {
    this.setState({ editMode: true })
  }
  _handleSaveEditClick () {
    this.setState({ editMode: false })
    const { category, id } = this.props.match.params
    // console.log('category: ', category)
    // console.log('id: ', id)
    this.props.fetchDetails(category, id)
  }
  _handleDisableEditMode () {
    this.setState({ editMode: false })
  }

  async _handleSendIdClick () {
    this.setState({ sendingSMS: true })
    const url = `${URL}send_auth`
    const config = {
      headers: {
        'Authorization': `Token ${this.props.user.token}`
      }
    }
    const data = {
      'owner_id': Number(this.props.activeDetails.data.id)
    }
    try {
      await axios.post(
        url,
        data,
        config
      )
      // console.log('res: ', res)
      this.setState({ sendingSMS: false })
      this.props.showToast('URLと管理用IDを送信しました！', 'primary')
    } catch (error) {
      this.props.showToast('エラーが発生しました。', 'danger')
    }
  }
  _handleAddPropertyClick () {
    this.props.history.push(`/owners/${this.props.activeDetails.data.id}/property/add`)
  }
  _handleAddCsv (e) {
    const csv = e.target.files[0]
    console.log(csv)
    if (csv) {
      if (csv.type === 'text/csv' && csv.name.indexOf('csv') > 0) {
        // this.setState({ image, imageURL: URL.createObjectURL(image) })
        // console.log('sending csv file')
        this.props.postCSV({ category_id: 0 }, csv)
      } else {
        console.log('wrong file type')
        // this.setState({ image_error: '画像ファイル外を選択しました。\n確認の上でもう一度画像ファイルを選択してください。' })
      }
    }
  }

  _sendSMS = async () => {
    try {
      const url = `${URL}sms`
      const config = {
        headers: {
          'Authorization': `Token ${this.props.user.token}`
        }
      }
      const data = {
        resident_id: this.props.activeDetails.data.id,
        message: smsMessage
      }
      const res = await axios.post(
        url,
        data,
        config
      )
      if (res.data.limit) {
        this.props.showToast('一日の制限を超えました。', 'danger')
      } else {
        this.props.showToast('SMS送信しました。', 'primary')
      }
    } catch (error) {
      this.props.showToast('SMS送信に失敗しました。', 'danger')
    }
  }

  _renderTitle () {
    let categoryTitle
    switch (this.props.activeDetails.category) {
      case 'owners':
        categoryTitle = '管理会社・オーナー'
        break
      case 'residents':
        categoryTitle = '入居者'
        break
      default:
        break
    }
    return <h4 className="bold">{categoryTitle}詳細</h4>
  }

  _renderData () {
    let dataLabels
    switch (this.props.activeDetails.category) {
      case 'owners':
        dataLabels = [
          {
            key: 'id',
            label: 'オーナーID'
          },
          {
            key: 'bits_owner_id',
            label: 'BITSオーナーID'
          },
          {
            key: 'name',
            label: '管理会社・オーナー名'
          },
          {
            key: 'tel',
            label: '電話番号'
          },
          {
            key: 'contact_name',
            label: '担当者氏名'
          },
          {
            key: 'contact_tel',
            label: '担当者電話番号'
          },
          {
            key: 'address',
            label: '住所'
          },
          {
            key: 'email',
            label: 'メールアドレス'
          },
          {
            key: 'business_hours',
            label: '営業時間・定休日'
          },
          {
            key: 'registered_users',
            label: '現在のアプリ利用数'
          },
          {
            key: 'hp_url',
            label: '管理会社ホームページ'
          },
          {
            key: 'image',
            label: '管理会社画像'
          }
        ]
        break
      case 'properties':
        dataLabels = [
          {
            key: 'property_id',
            label: '物件ID'
          },
          {
            key: 'owner_id',
            label: 'オーナーID'
          },
          {
            key: 'place',
            label: '住所'
          },
          {
            key: 'name',
            label: '物件名'
          },
          {
            key: 'tel',
            label: '問合せ先電話番号'
          },
          {
            key: 'email',
            label: 'メールアドレス'
          },
          {
            key: 'image',
            label: 'メインビジュアル画像'
          }
        ]
        break
      case 'residents':
        dataLabels = [
          {
            key: 'bits_property_id',
            label: 'BITS物件ID'
          },
          {
            key: 'property_name',
            label: '物件名'
          },
          {
            key: 'last_name',
            label: '姓'
          },
          {
            key: 'first_name',
            label: '名'
          },
          {
            key: 'furigana',
            label: 'フリガナ'
          },
          {
            key: 'birthday',
            label: '生年月日'
          },
          {
            key: 'sex',
            label: '性別'
          },
          {
            key: 'tel',
            label: '電話番号'
          },
          {
            key: 'emergency_tel',
            label: '緊急連絡先'
          },
          {
            key: 'room_no',
            label: '部屋番号'
          },
          {
            key: 'wifi_ssid',
            label: 'SSID'
          },
          {
            key: 'wifi_encrypt_key',
            label: '暗号化キー'
          }
        ]
        break
      default:
        break
    }
    if (dataLabels) {
      const { data } = this.props.activeDetails
      // console.log('data: ', data)
      return dataLabels.map(item => {
        // console.log('item: ', item)
        switch (item.key) {
          case 'hp_url':
            return (
              <div className="group" key={item.key}>
                <div className="label">{ item.label }</div>
                <a href={ data[item.key] } className="value flex align-center link medium" target="_blank">
                  <svg viewBox="0 0 24 24" className="icon_send">
                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                    <polyline points="15 3 21 3 21 9"></polyline>
                    <line x1="10" y1="14" x2="21" y2="3"></line>
                  </svg>
                  { data[item.key] }
                </a>
              </div>
            )

          case 'image':
            return (
              <div className="group" key={item.key}>
                <div className="label">{ item.label }</div>
                <div className="value medium img_container">
                  <img className="img_responsive" src={ data[item.key] } alt="" />
                </div>
              </div>
            )

          case 'sex':
            let sex = ''
            if (data[item.key] === 1) {
              sex = '男'
            } else if (data[item.key] === 2) {
              sex = '女'
            }
            return (
              <div className="group" key={item.key}>
                <div className="label">{ item.label }</div>
                <div className="value medium">{ sex }</div>
              </div>
            )

          default:
            return (
              <div className="group" key={item.key}>
                <div className="label">{ item.label }</div>
                <div className="value medium">{ data[item.key] }</div>
              </div>
            )
        }
      })
    }
    return null
  }

  _renderBtns () {
    const id = this.props.activeDetails.data.id
    switch (this.props.activeDetails.category) {
      case 'owners':
        return this._renderOwnerBtns(id)
      case 'residents':
        return this._renderResidentsBtns(id)
      default:
        break
    }
  }
  _renderOwnerBtns () {
    // const id = this.props.activeDetails.data.id
    return (
      <RoleControlled role={this.props.user.user_role} acceptedRoles={[0]}>
        <div className="btn_group">
          <button
            id="send_sms"
            className="btn secondary flex align-center"
            onClick={this._handleSendIdClick.bind(this)}
            disabled={this.state.sendingSMS}
          >
            {
              this.state.sendingSMS
                ? <Loader classname="loader_dot_circle" />
                : (
                  <svg viewBox="0 0 24 24" className="icon_send">
                    <line x1="22" y1="2" x2="11" y2="13"></line>
                    <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                  </svg>
                )
            }
            <span>このオーナー・管理会社に管理画面のURLと管理用IDを伝える</span>
          </button>
          <button className="btn primary flex align-center" onClick={this._handleAddPropertyClick.bind(this)}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="icon-add">
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
            <span>このオーナー・管理会社の物件を追加する</span>
          </button>
          <label htmlFor="add_csv" className="btn download_btn flex align-center">
            <svg viewBox="0 0 24 24" className="icon_upload">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
              <polyline points="17 8 12 3 7 8"></polyline>
              <line x1="12" y1="3" x2="12" y2="15"></line>
            </svg>
            <span>CSVでこのオーナー・管理会社の物件を追加する</span>
          </label>
          <a className="small csv_example" href={CSV}>CSVのフォーマットをダウンロード</a>
          <input
            type="file"
            id="add_csv"
            onChange={this._handleAddCsv.bind(this)}
          />
        </div>
      </RoleControlled>
    )
  }

  _renderResidentsBtns () {
    // const id = this.props.activeDetails.data.id

    return (
      <RoleControlled role={this.props.user.user_role} acceptedRoles={[0, 1]}>
        <div className="btn_group">
          <button className="btn chat_btn flex align-center">
            <svg viewBox="0 0 24 24" className="icon_chat">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
            </svg>
          チャットへ
          </button>
        </div>
      </RoleControlled>
    )
  }
  _renderWifiStatusTag () {
    if (this.props.activeDetails.category === 'residents') {
      let wifiStatus
      switch (this.props.activeDetails.data.wifi_installation_status) {
        case 0:
          wifiStatus = '未着手'
          break
        case 1:
          wifiStatus = '工事中'
          break
        case 2:
          wifiStatus = '完了'
          break
        default:
          wifiStatus = ''
          break
      }
      return (
        <div className="tag_container flex column">
          <div className="label">WIFI 工事状況</div>
          <div className="tag">{wifiStatus}</div>
        </div>
      )
    }
    return null
  }
  _renderResidentVerified () {
    if (this.props.activeDetails.category === 'residents') {
      if (!this.props.activeDetails.data.verified) {
        return (
          <div className="btn_group">
            <button className="btn primary flex align-center" onClick={this._sendSMS}>
              <svg viewBox="0 0 24 24" className="icon_chat">
                <rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect>
                <line x1="12" y1="18" x2="12" y2="18"></line>
              </svg>
              SMS送信
            </button>
          </div>
        )
      }
      return null
    }
    return null
  }

  _renderMemo () {
    switch (this.props.activeDetails.category) {
      case 'owners':
        return (
          <RoleControlled role={this.props.user.user_role} acceptedRoles={[0]}>
            <div className="group memo_group">
              <div className="label">メモ</div>
              <div className="memo">{ this.props.activeDetails.data.memo }</div>
            </div>
          </RoleControlled>
        )
      default:
        return (
          <div className="group memo_group">
            <div className="label">メモ</div>
            <div className="memo">{ this.props.activeDetails.data.memo }</div>
          </div>
        )
    }
  }

  _renderDetails () {
    return (
      <div className="details">
        { this._renderTitle() }
        <article>
          <div className="details_outer flex">
            <div className="details_right">
              { this._renderResidentVerified() }
              { this._renderWifiStatusTag() }
              { this._renderBtns() }
              { this._renderMemo() }
            </div>
            <div className="details_left">
              { this._renderData() }

              <div className="group">
                <div className="label">作成日</div>
                <div className="value medium">{ this.props.activeDetails.data.created_date }</div>
              </div>
            </div>
          </div>
          <div className="button_container flex">
            <BackButton />
            {
              this.props.activeDetails.category === 'residents'
                ? (
                  <RoleControlled role={this.props.user.user_role} acceptedRoles={[0, 1]}>
                    <button className="btn edit primary flex" onClick={this._handleEditClick.bind(this)}>
                      <svg viewBox="0 0 24 24" className="icon_edit">
                        <path d="M20 14.66V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5.34"></path>
                        <polygon points="18 2 22 6 12 16 8 16 8 12 18 2"></polygon>
                      </svg>
                      <span>編集</span>
                    </button>
                    <button className="btn delete red flex" onClick={this._handleDeleteClick.bind(this)}>
                      <svg viewBox="0 0 24 24" className="icon_edit">
                        <polyline points="3 6 5 6 21 6"></polyline>
                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                        <line x1="10" y1="11" x2="10" y2="17"></line>
                        <line x1="14" y1="11" x2="14" y2="17"></line>
                      </svg>
                      <span>削除</span>
                    </button>
                  </RoleControlled>
                )
                : [
                  <RoleControlled role={this.props.user.user_role} acceptedRoles={[0, 1]} key="edit">
                    <button className="btn edit primary flex" onClick={this._handleEditClick.bind(this)}>
                      <svg viewBox="0 0 24 24" className="icon_edit">
                        <path d="M20 14.66V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5.34"></path>
                        <polygon points="18 2 22 6 12 16 8 16 8 12 18 2"></polygon>
                      </svg>
                      <span>編集</span>
                    </button>
                  </RoleControlled>,
                  <RoleControlled role={this.props.user.user_role} acceptedRoles={[0]} key="delete">
                    <button className="btn delete red flex" onClick={this._handleDeleteClick.bind(this)}>
                      <svg viewBox="0 0 24 24" className="icon_edit">
                        <polyline points="3 6 5 6 21 6"></polyline>
                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                        <line x1="10" y1="11" x2="10" y2="17"></line>
                        <line x1="14" y1="11" x2="14" y2="17"></line>
                      </svg>
                      <span>削除</span>
                    </button>
                  </RoleControlled>
                ]
            }
          </div>
        </article>
      </div>
    )
  }

  _renderEditForm () {
    switch (this.props.activeDetails.category) {
      case 'owners':
        return <EditOwner data={this.props.activeDetails.data} close={this._handleDisableEditMode.bind(this)} save={this._handleSaveEditClick.bind(this)}/>
      case 'residents':
        return <EditResident data={this.props.activeDetails.data} close={this._handleDisableEditMode.bind(this)} save={this._handleSaveEditClick.bind(this)}/>
      default:
        return null
    }
  }

  render () {
    if (this.props.activeDetails.loading) {
      return <Loader classname="loader_dot_circle"/>
    }

    return this.state.editMode
      ? this._renderEditForm()
      : this._renderDetails()
  }
}

function mapStateToProps ({ user, activeDetails }) {
  return { user, activeDetails }
}

export default connect(mapStateToProps, { fetchDetails, resetDetails, showToast, deleteDetails, postCSV })(Details)



// WEBPACK FOOTER //
// ./src/components/Details/index.js